import {
  GetCurrentCognitoSession,
  GetCurrentCognitoUser,
} from 'app/utils/aws/awsCognito';


export async function getCognitoSession(): Promise<any> {
  try {
    const session = await GetCurrentCognitoSession();
    return session;
  } catch (error) {
    return null;
  }
}
export async function getCognitoUser(): Promise<any> {
  try {
    const user = await GetCurrentCognitoUser();
    return user;
  } catch (error) {
    return null;
  }
}

export async function getJwtToken(): Promise<any> {
  const cognitoSession = await getCognitoSession();

  if (cognitoSession === undefined || cognitoSession === null) {
    return null;
  }
  return cognitoSession.getIdToken().getJwtToken();
}

export async function getAdminId(): Promise<any> {
  const cognitoUser = await getCognitoUser();
  if (cognitoUser === undefined || cognitoUser === null) {
    return null;
  }
  const adminId = cognitoUser.getUsername();
  return adminId;
}

export async function getExpiredTokenTime(): Promise<any> {
  const cognitoSession = await getCognitoSession();

  if (cognitoSession === undefined || cognitoSession === null) {
    return null;
  }
  return cognitoSession.idToken.payload.exp;
}

export async function isAuthenticated(): Promise<any> {
  const authentication = await getCognitoSession();
  const authenticated = authentication !== null;
  return authenticated;
}

export function getAuthentication(state): any {
  return {
    ...state.authentication,
    isAuthenticated: isAuthenticated(),
  };
}
export default null;
